;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import {
  PaginatedStocklistSourcesResult,
  type StocklistSourceExpiryStatus,
} from '@qogita/canary-client/sellers'
import { CanaryClient } from '@qogita/deprecated-canary-client'
import { useCanaryClient } from '@qogita/deprecated-canary-client/provider'
import {
  queryOptions,
  type UseQueryOptions,
  useSuspenseQuery,
} from '@tanstack/react-query'
import { PAGE_SIZE } from 'src/deprecated/constants'
import { getStocklistSourcesQueryKey } from 'src/deprecated/utils/queryKey'

type UseGetStocklistSourcesProps = {
  page: number
  pageSize?: number
  status?: StocklistSourceExpiryStatus
} & Pick<UseQueryOptions, 'retry' | 'enabled'>

const getStocklistSources = ({
  page,
  pageSize,
  status,
  canaryClient,
}: {
  page: number
  pageSize: number
  status?: StocklistSourceExpiryStatus
  canaryClient: CanaryClient
}) => canaryClient.getStocklistSources({ page, pageSize, status })

export const getStocklistSourcesQueryOptions = ({
  page,
  pageSize,
  status,
  canaryClient,
}: {
  page: number
  pageSize: number
  status?: StocklistSourceExpiryStatus
  canaryClient: CanaryClient
}) =>
  // TODO: resolve this by moving to RSC or adding the missing dependency
  // oxlint-disable-next-line @tanstack/query/exhaustive-deps
  queryOptions({
    queryKey: getStocklistSourcesQueryKey(page, pageSize, status),
    queryFn: () =>
      getStocklistSources({ page, pageSize, status, canaryClient }),
  })

export const useSuspenseGetStocklistSources = ({
  page,
  pageSize = PAGE_SIZE,
  status,
  ...props
}: UseGetStocklistSourcesProps) => {
  const canaryClient = useCanaryClient()
  // oxlint-disable-next-line @tanstack/query/no-rest-destructuring
  const { data, ...rest } = useSuspenseQuery<
    PaginatedStocklistSourcesResult,
    TypeError | Error
    // TODO: resolve this by moving to RSC or adding the missing dependency
    // oxlint-disable-next-line @tanstack/query/exhaustive-deps
  >({
    queryKey: getStocklistSourcesQueryKey(page, pageSize, status),
    queryFn: () =>
      getStocklistSources({ page, pageSize, status, canaryClient }),
    ...props,
  })

  return {
    ...rest,
    stocklistSources: data?.results ?? [],
    totalResults: data?.count ?? 0,
    totalPages: data ? Math.ceil(data.count / pageSize) : 0,
  }
}
